

import { AppBar, Container, Toolbar, Box, List, ListItem } from "@mui/material"

import { ListItemPerfil } from "./ListItemPerfil "

import { DialogTokenExpired } from "../dialogs/DialogTokenExpired"
import { DialogSesionCambiada } from "../dialogs/DialogSesionCambiada"
import { DialogNuevaVersion } from "../dialogs/DialogNuevaVersion"

export const NavBar = () => {
    
    return (
        <>
            <DialogTokenExpired />

            <DialogSesionCambiada />

            <DialogNuevaVersion />
        
            <AppBar position="fixed" style={{ boxShadow: 'none', backgroundColor: 'white', borderBottom: '3px solid #0A192D' }}>

                <Container maxWidth="xl" sx={{ backgroundColor: 'white' }}>

                    <Toolbar 
                        disableGutters
                        sx={{ backgroundColor: 'white', height: 85 }}
                    >
                    
                        <Box sx={{ textAlign: 'start' }}>               

                            <img 
                                style={{ height: 60 }}
                                src={ process.env.PUBLIC_URL + "/assets/logo-saji.png"}
                                alt='logo'
                            />                       
                            
                        </Box>  

                        <Box sx={{ flex: 1 }}>

                            <List component="nav">
                            
                                <ListItem component="div">  
                                    
                                

                                </ListItem>

                            </List>

                        </Box>                  

                        <Box sx={{ display: 'flex' }}>
                            
                            <List component="nav">

                                <ListItemPerfil /> 

                            </List>

                        </Box>                  

                    </Toolbar>

                </Container>

            </AppBar>
        </>
    )
}